import { useMutation } from 'react-query'
import { toast } from 'react-toastify'
import { addNewBankCard } from 'services/bankManagements'
interface IPayload {
    cardNumber: string
    isIban: boolean
}
export default function useSetAddCard(
    setIsOpen: React.Dispatch<React.SetStateAction<boolean>>
) {
    const { isLoading, mutate, data } = useMutation({
        mutationFn: (payload: IPayload) => {
            return addNewBankCard(payload.cardNumber, payload.isIban)
        },
        onSuccess: (_, variables) => {
            setIsOpen(true)
        },
        onError: (error: any) => {
            // 406 is the server refusing a card/IBAN this member already has
            // verified. «خطایی رخ داده!» sent managers round the add form
            // again and again for an account that was already there.
            if (error?.response?.status === 406) {
                toast.error('این حساب قبلاً به نام شما ثبت شده است')
                return
            }
            toast.error('خطایی رخ داده!')
        },
    })

    return { isLoading, mutate, data }
}
